import { render } from "./slider.vue?vue&type=template&id=4e649402"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import exportComponent from "F:\\hatem\\vue\\sanhory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__